import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as g from '@app/globals';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable, throwError } from 'rxjs';
import { retryWhen } from 'rxjs/internal/operators/retryWhen';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { catchError, delay, retry, take, tap } from 'rxjs/operators';
@Injectable()
export class EmailsService {
  constructor(
    private http: HttpClient,
    private notification: NzNotificationService
  ) {}
  getHeaders() {
    let options: HttpHeaders = new HttpHeaders();
    options = options.append(
      'Authorization',
      'Bearer ' + localStorage.getItem('emails_token')
    );
    return options;
  }
  getEmailsFromList() {
    return this.http
      .get(`${g.emailsServiceUrl}EmailFroms?includeAll=true`, {
        headers: this.getHeaders(),
      })
      .pipe(
        catchError((error) => {
          console.log(error);
          this.handleError(error, this.getEmailsFromList());
          return throwError(error);
        })
      );
  }

  getEmailFromDetails(id: string) {
    return this.http.get(`${g.emailsServiceUrl}EmailFroms/${id}`);
  }

  assignEmailFrom(empId: number, emailFromId: string) {
    return this.http.post(`${g.apiBaseUrl}ApiCommunication/HandleEmailFrom`, {
      emailFromId: emailFromId,
      empId: empId,
    });
  }
  getToken() {
    return this.http
      .post(`${g.emailsServiceUrl}Authentication/Login`, {
        UserName: g.emailsServiceCreds.username,
        Password: g.emailsServiceCreds.password,
      })
      .pipe(
        tap((response: any) => {
          localStorage.setItem('emails_token', response.token);
        })
      );
  }

  handleError(error, func: Observable<any>) {
    if (error.status === 401) {
      console.error('Unauthorized:', error);
      this.getToken()
        .pipe(switchMap(() => func))
        .subscribe();
    } else {
      this.notification.error(
        'Emails service error',
        'Emails service is not running, please restart it and try again'
      );
    }
    console.log(error.type);
  }
}
